import { render } from "./coaches-list-sidebar.vue?vue&type=template&id=252708ef"
import script from "./coaches-list-sidebar.vue?vue&type=script&lang=js"
export * from "./coaches-list-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__